import React, { Component } from "react";
// import { NavLink } from 'react-router-dom';
import CourseCodeSmall from "./CourseCodeSmall";
import CookieValue from "../../../utils/cookie_value";
import ApiCall from "../../../utils/api_call";
import FetchResource from "../../../utils/fetch_resource";
import Filters from "./Filters";
import ProgressBar from "../ProgressBar";
import Cookies from "universal-cookie";
import Spinner from "../../Spinner";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

export default class SyllabiIndexMainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      syllabi: [],
      currentSubjects: [],
      unusedSubjects: [],
      redirect_to_syl: null,
      data_ready: false,
      display_error: false,
      userRole: props.userRole,
      semester: null,
      semesters: [],
      year: null,
      years: [],
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.fetchSyllabi({})
      .then(() => {
        if (this._isMounted) {
          this.setState({ data_ready: true });
        }
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          if (this._isMounted) {
            this.setState({ display_error: true });
          }
        }
      });
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    //TODO: figure out how to make the new syllabus show up in the listing
    //      after the user hits the back button.
    if (this._isMounted) {
      const redirect_id = this.state.redirect_to_syl;
      if (redirect_id) {
        this.setState({ redirect_to_syl: null });
        window.location = client_base + "syllabus/" + redirect_id;
      }
      if (this.props !== prevProps) {
        this.setState({
          userRole: this.props.userRole,
        });
      }
    }
  };

  fetchSyllabi = () => {
    const { year, semester } = this.state;
    let url = api_base + "syllabi";
    let filters =
      this.state.currentSubjects.length > 0
        ? this.buildQuery("currentSubjects", "syllabus[subject_lookup_id]")
        : "";
    if (year > 0) {
      filters += `&year=${year}`;
    }
    if (semester > 0) {
      filters += `&semester=${semester}`;
    }

    return FetchResource(url, filters, this);
  };

  buildQuery = (key, paramName) => {
    return (
      paramName +
      "=" +
      this.state[key]
        .map((s, i) => {
          return s.id;
        })
        .join(",")
    );
  };

  addSyllabus = () => {
    const url = api_base + "syllabi/";
    const body = {
      syllabus: {
        course_code_a: ",,,,",
        credit_hours: "0",
      },
    };
    const reqOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      body: JSON.stringify(body),
    };
    ApiCall(url, reqOptions, this)
      .then((data) => {
        let state = this.state;
        state.syllabi.push(data);
        state.redirect_to_syl = data.id;
        this.setState(state);
        //Adding the new syllabus to the state before redirect,
        //so that it will appear on the listing if the user hits the
        //back button after being redirected.
        // window.location = client_base + 'syllabi/show/' + data.id;
        //This does not work yet.
      })
      .catch((err) => console.log(err));
  };

  removeSubjFilter = (opts, event) => {
    const { selectElem, paramArr, rmIx } = opts;
    const { currentSubjects, unusedSubjects } = this.state;
    unusedSubjects.unshift(currentSubjects.splice(rmIx, 1)[0]);
    this.setState({
      currentSubjects: currentSubjects,
      unusedSubjects: unusedSubjects,
    });
    this.fetchSyllabi().then().catch();
  };

  addSubjFilter = (opts, event) => {
    const { selectElem, paramArr, enabled } = opts;
    if ($("#" + selectElem).val() >= 0) {
      const { currentSubjects, unusedSubjects } = this.state;
      if (enabled) {
        currentSubjects.push(
          unusedSubjects.splice($("#" + selectElem).val(), 1)[0]
        );
        this.setState({
          currentSubjects: currentSubjects,
          unusedSubjects: unusedSubjects,
        });
      }
    }
    this.fetchSyllabi().then().catch();
  };

  setSigularFilter = (type, event) => {
    const state = {};
    state[type] = event.target.value;
    this.setState(state);
  };

  render() {
    let {
      currentSubjects,
      data_ready,
      userRole,
      semesters,
      syllabi,
      unusedSubjects,
      years,
    } = this.state;

    const isAdmin = userRole === "ADMIN";

    const sortedSyllabi = syllabi.sort((a, b) => {
      if (a.course_code_a < b.course_code_a) {
        return -1;
      }
      if (a.course_code_a > b.course_code_a) {
        return 1;
      }
      return 0;
    });

    const syllabi_list = sortedSyllabi.map((syl, i) => {
      return (
        <tr
          key={i}
          id={`syl-row-${syl.id}`}
          className="justify-content-left buffer-top test-syl-row"
        >
          <td className="inner-buffer">
            <CourseCodeSmall
              course_code_a={syl.course_code_a}
              subject={syl.subject}
            />
          </td>
          <td className="inner-buffer">
            <a href={"/syllabus/" + syl.id}>{syl.course_name}</a>
            <ProgressBar progressA={syl.progress_a} />
          </td>
          <td className="inner-buffer">
            <a href={"/syllabus/" + syl.id}>
              <button
                className="btn btn-info xs-font"
                style={{ lineHeight: "100%" }}
              >
                {" "}
                View{" "}
              </button>
            </a>
            {/* {isAdmin ? (
              <a href={"/syllabus/" + syl.id}>
                <button
                  className="btn btn-info xs-font"
                  style={{ lineHeight: "100%" }}
                > Edit ??? </button>
              </a>
            ) : <span></span>} */}
          </td>
        </tr>
      );
    });

    return (
      <div>
        <div className="container">
          <h1 className="d-flex flex-row justify-content-center">
            Course Syllabi
          </h1>
          {isAdmin ? (
            <button className="btn btn-primary" onClick={this.addSyllabus}>
              Create New Syllabus
            </button>
          ) : (
            ""
          )}
          <Filters
            selectId="subjFilterDD"
            removeFilter={this.removeSubjFilter}
            addFilter={this.addSubjFilter}
            currentFilters={currentSubjects}
            setSigularFilter={this.setSigularFilter}
            unusedFilters={unusedSubjects}
            years={years}
            semesters={semesters}
          />
          <div section="syllabi-list" className="top-buffer">
            {data_ready ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Course Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>{syllabi_list}</tbody>
              </table>
            ) : (
              <Spinner />
            )}
          </div>
        </div>
      </div>
    );
  }
}
